import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./views/Home.vue";
import Gallary from "./views/Gallary.vue";
import Brochure from "./views/Brochure.vue";
import Video1 from "./views/Video1.vue";
import Video2 from "./views/Video2.vue";
import Video3 from "./views/Video3.vue";
import Clothes from "./views/Clothes.vue";
import Facility from "./views/Facility.vue";
import Traffic from "./views/Traffic.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/Home",
    name: "Home",
    component: Home,
  },
  {
    path: "/Gallary",
    name: "Gallary",
    component: Gallary,
  },
  {
    path: "/Facility",
    name: "Facility",
    component: Facility,
  },
  {
    path: "/Brochure",
    name: "Brochure",
    component: Brochure,
  },
  {
    path: "/Video1",
    name: "Video1",
    component: Video1,
  },
  // {
  //   path: "/Video2",
  //   name: "Video2",
  //   component: Video2,
  // },
  {
    path: "/Video3",
    name: "Video3",
    component: Video3,
  },
  {
    path: "/Clothes",
    name: "Clothes",
    component: Clothes,
  },
  {
    path: "/Traffic",
    name: "Traffic",
    component: Traffic,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
